import { NavigationProvider } from 'contexts/NavigationContext'
import { BorderListProvider } from 'contexts/BorderListContext'
import { OrderInfoProvider } from 'contexts/OrderInfoContext'
import { LanguageProvider } from 'contexts/LanguageContext'
import { BrowserRouter as Router } from 'react-router-dom'
import { ConfigProvider } from 'contexts/ConfigContext'
import LocationListener from 'utils/LocationListener'
import { ModalProvider } from 'contexts/ModalContext'
import { AlertProvider } from 'contexts/AlertContext'
import { AuthProvider } from 'contexts/AuthContext'
import DamianAnalyst from 'utils/DamianAnalyst'
import * as nativeApp from 'utils/nativeApp'
import ReactDOM from 'react-dom/client'
import Alert from 'components/Alert'
import React from 'react'
import App from './App'
import './index.scss'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)

/**
 * Logs for iOS
 */
if (nativeApp.isIOS()) {
  console.log = function (log) {
    window.webkit.messageHandlers.Console.postMessage(JSON.stringify(log))
  };
  console.debug = console.log;
  console.info = console.log;
  console.warn = console.log;
  console.error = console.log;

  window.onerror = function (error, url, line) {
    console.log('ERROR: ' + error + ' URL:' + url + ' L:' + line);
  };
}

root.render(
  // <React.StrictMode>
  <AlertProvider>
    <DamianAnalyst>
      <Router>
        <Alert />
        <LanguageProvider>
          <AuthProvider>
            <ModalProvider>
              <ConfigProvider>
                <LocationListener>
                  <NavigationProvider>
                    <OrderInfoProvider>
                      <BorderListProvider>
                        <App />
                      </BorderListProvider>
                    </OrderInfoProvider>
                  </NavigationProvider>
                </LocationListener>
              </ConfigProvider>
            </ModalProvider>
          </AuthProvider>
        </LanguageProvider>
      </Router>
    </DamianAnalyst>
  </AlertProvider>
  // </React.StrictMode>
)
